// nl-BE UI labels — STUB, flagged for translation.
// Empty by design: falls back to English (en.js) per key. Human translation
// only. Copy keys from en.js, translate, then flip `translated: true` for "nl-BE"
// in i18n/languages.js.
export default {}
